/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Grid,
} from '@material-ui/core';

const styles = (theme) => ({
    welcomeText: {
        fontFamily: 'Lato, sans-serif',
        fontWeight: 400,
        fontSize: '16px !important',
        lineHeight: '17.37px',
        marginTop: '16px',
    },
    titleContainer: {
        marginTop: '20px',
        marginBottom: '24px',
        '@media (min-width:767px)': {
            margin: '28px 0px',
        },
    },
    titleText: {
        lineHeight: '37px',
        marginBottom: '8px !important',
        fontSize: '32px',
        '& > *': {
            fontFamily: 'Playfair Display !important',
            '@media (min-width:767px)': {
                fontSize: '40px !important',
                lineHeight: '38px',
            },
            '@media (min-width:1024px)': {
                fontSize: '50px !important',
                lineHeight: '58px',
            },
        }
    },
    responsiveText: {
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
        fontSize: '16px !important',
        '& span': {
            display: 'inline-block',
        },
        '& .noWrapSpan': {
            whiteSpace: 'nowrap',
        },
    },
    responsiveTitleText: {
        margin: '0 auto',
        '& span': {
            whiteSpace: 'normal'
        },
        '@media (min-width:400px)': {
            width: '90%'
        },
        '@media (min-width:769px)': {
            width: '65%'
        },
    },
    loginText: {
        fontFamily: 'Lato, sans-serif',
        fontWeight: 400,
        lineHeight: '21px',
    },
    staticLink: {
        fontWeight: 700,
        fontSize: '16px !important',
        fontFamily: 'Lato, sans-serif',
        textTransform: 'none',
        verticalAlign: 'top',
        textDecoration: 'underline',
        cursor: 'pointer',
        outline: 'none',
        textUnderlineOffset: '2px',
    },
    memberContainer: {
        border: '1px solid #BFBFBF',
        padding: '20px 24px',
        textAlign: 'center',
        margin: '0px 45px',
        marginBottom: '37px',
        '& p': {
            marginBottom: '0px !important',
        },
        '& span': {
            fontSize: '16px !important',
        },
    },
});

const CelebrationsRemindersHeader = ({ classes, handleSignIn }) => (
    <>
        <Grid item container direction="column" alignItems="center">
            <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M39.5833 8.49988H10.4167C8.11548 8.49988 6.25 10.4027 6.25 12.7499V42.4999C6.25 44.8471 8.11548 46.7499 10.4167 46.7499H39.5833C41.8845 46.7499 43.75 44.8471 43.75 42.4999V12.7499C43.75 10.4027 41.8845 8.49988 39.5833 8.49988Z"
                    stroke="#329A77"
                    strokeWidth="2.4375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M33.3333 4.25V12.75"
                    stroke="#329A77"
                    strokeWidth="2.4375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.6667 4.25V12.75"
                    stroke="#329A77"
                    strokeWidth="2.4375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.25 21.25H43.75"
                    stroke="#329A77"
                    strokeWidth="2.4375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <Typography
                variant="h6"
                align="center"
                className={classes.welcomeText}
            >
                CELEBRATIONS REMINDERS&reg;
            </Typography>
        </Grid>
        <Grid item className={classes.titleContainer}>
            <Typography align="center" className={`${classes.responsiveTitleText} ${classes.titleText}`}>
                <span>Set a Reminder by Entering a Loved One's Birthday or Special Occasion.</span>
            </Typography>
        </Grid>
        <Grid
            item
            xs={12}
            className={classes.memberContainer}
        >
            <Typography className={`${classes.responsiveText} ${classes.loginText}`}>
                <span>Already a member?</span>
                {' '}
                <span className={classes.noWrapSpan}>
                        <span
                            role="button"
                            tabIndex={-1}
                            onClick={handleSignIn}
                            onKeyDown={handleSignIn}
                            className={classes.staticLink}
                        >
                            Log in
                        </span>{' '}
                        to update your contacts.
                    </span>
            </Typography>
        </Grid>
    </>
);

CelebrationsRemindersHeader.propTypes = {
    handleSignIn: func.isRequired,
    classes: object,
};

CelebrationsRemindersHeader.defaultProps = {
    classes: {},
};

export default withStyles(styles)(CelebrationsRemindersHeader);
